module.exports = __webpack_public_path__ + "static/img/fog.2005eff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fog.jpeg
// module id = YdSO
// module chunks = 1